var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31.877,
    rx: 15.939,
    fill: "#E9ECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.124 19.153a6.832 6.832 0 1 0-.838.86l3.709 3.708a.6.6 0 0 0 .849-.849l-3.72-3.72Zm-5.282 1.315a5.61 5.61 0 1 1-.01-11.22 5.61 5.61 0 0 1 .01 11.22Z",
    fill: "#868E96"
  })));
};
export default SvgSearchIcon;